import { useDisclosure } from '@shared/hooks';

import { Timer, TimerSkeleton } from '../../../../components';
import { ExamEndingSubmissionModal } from '../../../exam/components';

interface ExamTimerProps {
  loading: boolean;
  onSubmit: () => Promise<void>;
  examStartedAt: Date;
  examEndedAt: Date;
}

export default function ExamTimer(props: Readonly<ExamTimerProps>) {
  const { loading, examStartedAt, examEndedAt, onSubmit } = props;

  const [
    isEndingSubmissionModalOpen,
    { open: openEndingSubmissionModal, close: closeEndingSubmissionModal },
  ] = useDisclosure(false);

  const handleSubmitExam = async () => {
    await onSubmit();
    closeEndingSubmissionModal();
  };

  if (loading)
    return (
      <div className='h-12 w-50'>
        <TimerSkeleton className='h-full w-full' />
      </div>
    );

  return (
    <>
      <Timer
        startedAt={examStartedAt}
        adjustedEndedAt={examEndedAt}
        displayedEndedAt={examEndedAt}
        onTimerEnd={openEndingSubmissionModal}
      />
      <ExamEndingSubmissionModal
        open={isEndingSubmissionModalOpen}
        onSubmitExam={handleSubmitExam}
        submitting={false}
      />
    </>
  );
}
